import { TESTIMONIALS } from "@/mocks/gossip";

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-accent-700 uppercase">
              <i className="ri-book-2-line" aria-hidden="true"></i>
              About
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">把热闹，讲成一本圈层图鉴</h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700">
              国产吃瓜相信：真正值得回味的不是一句热搜标题，而是名场面背后的现场、人物与圈子关系。所以我们不像搬运号那样追着话题跑，而是沉下心，把明星、网红、综艺与剧组的高能瞬间归档成图鉴，供你按需、按圈层慢慢翻看。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              我们坚持内容有语境、表达有分寸，倡导「先看语境、再理性参与」。这里没有无中生有的情绪挑动，只有尽量还原现场的温度与细节。
            </p>
            <dl className="mt-8 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {[
                { n: "120+", l: "名场面收录" },
                { n: "4", l: "核心圈层" },
                { n: "24/7", l: "滚动更新" },
              ].map((s) => (
                <div key={s.l}>
                  <dt className="sr-only">{s.l}</dt>
                  <dd className="font-heading text-3xl font-black text-primary-600">{s.n}</dd>
                  <dd className="mt-1 text-xs text-foreground-600">{s.l}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-1">
            {TESTIMONIALS.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col gap-3 rounded-2xl border border-background-200 bg-background-100/60 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-secondary-400" aria-hidden="true"></i>
                <blockquote className="text-sm leading-relaxed text-foreground-800">“{t.text}”</blockquote>
                <figcaption className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{t.name}</span>
                    <span className="block text-xs text-foreground-600">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}